<div class="popup-specification">
  <ng-container>
    <nb-card size="medium" class="nb-card" [nbSpinner]="loading" nbSpinnerStatus="info">
      <nb-card-header>
        <div class="title">Перенос задачи</div>
      </nb-card-header>
      <nb-card-body>
        <form class="b-form" [formGroup]="timeForm" style="padding: 1rem 1.5rem;">
          <div class="box-modal-date-padding">
            <div>Выберите проект</div>
            <ng-select
              (change)="change($event)"
              [items]="allProjects"
              bindLabel="header"
              bindValue="id"
              [clearable]="false"
              [(ngModel)]="selectedRow"
              placeholder="Выберите проект"
            >
            </ng-select>
            <div>Перенести время из задачи в другой проект?</div>
            <input type="checkbox" [(ngModel)]="timeMove" [checked]="timeMove" (change)="checkValue($event)">
          </div>
          <button nbButton status="primary" (click)="moveToProject()">Поехали!</button>
        </form>
      </nb-card-body>
    </nb-card>
  </ng-container>
</div>
